<template>
  <div>
    <TextBlockWithHeader
    title="Лицензии и сертификаты"
    text="Лицензии и сертификаты подтверждают наши компетенции и доверие со стороны Федеральных органов власти."
    theme="dark"
    />
    <HorizontalBlocksWithPictureTitleAndText
        title=""
        :items="licenseItems"
    />
  </div>
</template>

<script>
import { TextBlockWithHeader, HorizontalBlocksWithPictureTitleAndText } from 'sputnik-ui/src/index';

export default {
  name: 'DocumentsPage',
  components: {
    TextBlockWithHeader,
    HorizontalBlocksWithPictureTitleAndText
  },
  data() {
    return {
      licenseItems: [
        {
          "imagePath": require('../assets/imgs/minobr.png'),
          "title": "Лицензия Министерства Обороны Российской Федерации № 2477 от 10.12.2024",
          "subtitle": "Действительна до 10 декабря 2029 г.",
          "text": "На проведение работ, связанных с созданием средств защиты информации."
        },
        {
          "imagePath": require('../assets/imgs/fsb.png'),
          "title": "Лицензия ФСБ России (ГТ) №36369",
          "subtitle": "Действительна до 24 июля 2031 г.",
          "text": "На проведение работ, связанных с использованием сведений, составляющих государственную тайну."
        },
        {
          "imagePath": require('../assets/imgs/fsb.png'),
          "title": "Лицензия ФСБ России на криптографию №17835",
          "subtitle": "Бессрочная.",
          "text": "На осуществление разработки, производства, распространения шифровальных (криптографических) средств, информационных систем и телекоммуникационных систем."
        },
        {
          "imagePath": require('../assets/imgs/FSTEC.png'),
          "title": "Лицензия ФСТЭК России (РиПСЗКИ) №1976 от 26.10.2020",
          "subtitle": "Бессрочная.",
          "text": "На осуществление деятельности по разработке и производству средств защиты конфиденциальной информации (программных средств защиты информации, защищенных программных средств обработки информации и программных средств контроля защищенности информации).",
        },
        {
          "imagePath": require('../assets/imgs/FSTEC.png'),
          "title": "Лицензия ФСТЭК России (ТЗКИ) №3826 от 26.10.2020",
          "subtitle": "Бессрочная.",
          "text": "На осуществление деятельности по технической защите конфиденциальной информации в части: контроля защищенности конфиденциальной информации от несанкционированного доступа, проектирования информационных систем в защищенном исполнении, а также установки, монтажа, испытаний и ремонта средств защиты информации и защищенных программных (программно-технических) средств обработки информации."
        },
        {
          "imagePath": require('../assets/imgs/FSTEC.png'),
          "title": "Лицензия ФСТЭК России (СЗИ) №3607",
          "subtitle": "В процессе продления.",
          "text": "На проведение работ, связанных с созданием средств защиты информации."
        },
      ],
    }
  },
};
</script>

<style lang="scss" scoped>

</style>
